import { render, staticRenderFns } from "./FileZone.vue?vue&type=template&id=1ab7b93a"
import script from "./FileZone.vue?vue&type=script&lang=js"
export * from "./FileZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports